import { useParams } from 'react-router-dom';
import BackButton from '../Components/BackButton';
import { usePools } from '../DatabaseContext';
import React, { useEffect, useState } from 'react';
import ChoiceQuestion from '../Fields/ChoiceQuestion';
import FormContainer from '../Fields/FormContainer';
import NumberQuestion from '../Fields/NumberQuestion';
import SaveAndContinue from '../Fields/SaveAndContinue';
import BubbleLoader from '../../../Libraries/Loader/bubble-loader';
import TextQuestion from '../Fields/TextQuestion';

export default function AdvancedEditPage({ i18n }) {
    const { id } = useParams()
    const { setPoolId, pool } = usePools()

    const [waterTableHeight, setWaterTableHeight] = useState('');
    const [waterCharacteristics, setWaterCharacteristics] = useState('');
    const [waterPumpInformation, setWaterPumpInformation] = useState('');
    const [waterPumpKw, setWaterPumpKw] = useState(0);
    const [windSpeed, setWindSpeed] = useState(4);
    const [pumpRunningHours, setPumpRunningHours] = useState('');
    const [people, setPeople] = useState('');

    const updateFields = async () => {
        setWaterTableHeight(pool?.water_table_height);
        setWaterCharacteristics(pool?.water_characteristics);
        setWaterPumpInformation(pool?.water_pump_information);
        setPumpRunningHours(pool?.pump_running_hours);
        setPeople(pool?.number_of_people);
        setWindSpeed(pool?.wind_speed);
        setWaterPumpKw(pool?.water_pump_kw);
    }

    const notReady = () => {
        return !(
            id &&
            pool
        );
    }

    useEffect(() => {
        setPoolId(id)
    }, [id])

    useEffect(() => {
        updateFields();
    }, [pool])

    if (notReady()) {
        return <BubbleLoader />
    }

    return <FormContainer breadcrumb={[
        { label: pool.name, url: `/${pool.id}/name` },
        { label: i18n.dimensions.heading, url: `/${pool.id}/dimensions` },
        { label: i18n.temperature.heading, url: `/${pool.id}/temperature` },
        { label: i18n.location.heading, url: `/${pool.id}/location` },
        { label: i18n.seasons.heading, url: `/${pool.id}/seasons` },
        { label: i18n.power.heading, url: `/${pool.id}/power` },
        { label: i18n.advanced.heading },
    ]} >
        <div className="mt-4 grid grid-cols-1 gap-4 sm:gap-8">
            <div>
                <ChoiceQuestion
                    label={ i18n.advanced.waterTableHeight }
                    name="water_table_height"
                    onChange={ setWaterTableHeight }
                    value={ waterTableHeight }
                    options={[
                        { label: i18n.advanced.high, value: 'High' },
                        { label: i18n.advanced.low, value: 'Low' },
                    ]}
                />
            </div>
            <div>
                <ChoiceQuestion
                    label={ i18n.advanced.waterCharacteristics }
                    name="water_characteristics"
                    onChange={ setWaterCharacteristics }
                    value={ waterCharacteristics }
                    options={[
                        { label: i18n.advanced.still, value: 'Still' },
                        { label: i18n.advanced.moving, value: 'Moving' },
                    ]}
                />
            </div>
            <div>
                <NumberQuestion
                    value={ pumpRunningHours }
                    onChange={ setPumpRunningHours }
                    name="running_hours"
                    label={ i18n.advanced.pumpRunningHours }
                />
            </div>
            <div>
                <NumberQuestion
                    value={ windSpeed }
                    onChange={ setWindSpeed }
                    name="wind_speed"
                    label={ i18n.advanced.windSpeedInKph }
                />
            </div>
            <div>
                <NumberQuestion
                    value={ waterPumpKw }
                    onChange={ setWaterPumpKw }
                    name="water_pump_kw"
                    label={ i18n.advanced.waterPumpKw }
                />
            </div>
            <div>
                <TextQuestion
                    value={ waterPumpInformation || '' }
                    onChange={ setWaterPumpInformation }
                    name="pump_information"
                    label={ i18n.advanced.waterPumpInformation }
                    small={ true }
                />
            </div>
            <div>
                <NumberQuestion
                    value={ people }
                    onChange={ setPeople }
                    name="people"
                    label={ i18n.advanced.numberOfPeople }
                />
            </div>
        </div>

        <div className="flex flex-wrap items-center md:space-x-10">
            <SaveAndContinue text={ i18n.forms.saveReview } id={ pool?.id } data={{
                water_table_height: waterTableHeight,
                water_characteristics: waterCharacteristics,
                water_pump_kw: waterPumpKw,
                wind_speed: windSpeed,
                water_pump_information: waterPumpInformation,
                pump_running_hours: pumpRunningHours,
                number_of_people: people,
            }} next="summary" />
            <BackButton className="mt-8 md:mt-12" url={`/${pool.id}/summary`} />
        </div>

    </FormContainer>
}
